import { GridTableRow } from "../general/Tables/GridTable/GridTable";
import styles from "./Reconciliation.module.scss";

export const ReconciliationEmptyRow: React.FC = () => (
    <GridTableRow columnBorders>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div className={styles.actionsCell}>&nbsp;</div>
    </GridTableRow>
);
